import 'typeface-rubik'

import wrap from './src/templates/wrap-root-element'

export const wrapRootElement = wrap
